module.exports = __webpack_public_path__ + "static/img/10.7d8ce07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/sp/10.png
// module id = xufu
// module chunks = 0